const MAX_DIMENSION = 2048;
const JPEG_QUALITY = 0.9;
const JPEG_MIME = 'image/jpeg';
const DEFAULT_FILENAME = 'image.jpg';

export const processImageFile = async (file) => {
  if (!file) {
    throw new Error('No file provided');
  }

  const isAlreadyStandard = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp';
  
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.onload = () => {
      const img = new Image();

      img.onerror = () => {
        if (isAlreadyStandard) {
          resolve({
            file,
            preview: reader.result,
          });
          return;
        }
        reject(new Error('Failed to load image'));
      };

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
          if (width > height) {
            height = Math.round((height * MAX_DIMENSION) / width);
            width = MAX_DIMENSION;
          } else {
            width = Math.round((width * MAX_DIMENSION) / height);
            height = MAX_DIMENSION;
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve({
            file,
            preview: reader.result,
          });
          return;
        }

        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve({
                file,
                preview: reader.result,
              });
              return;
            }

            const fileName = file.name ? file.name.replace(/\.[^/.]+$/, '') + '.jpg' : DEFAULT_FILENAME;
            const convertedFile = new File([blob], fileName, {
              type: JPEG_MIME,
              lastModified: Date.now(),
            });

            const previewUrl = canvas.toDataURL(JPEG_MIME, JPEG_QUALITY);

            resolve({
              file: convertedFile,
              preview: previewUrl,
            });
          },
          JPEG_MIME,
          JPEG_QUALITY
        );
      };

      img.src = reader.result;
    };

    reader.readAsDataURL(file);
  });
};
